export var SKETCH = 8;
export var DESIGN_TOOL = 7;
